/* Number of sub-questions in numerical question*/
export const QUESTIONS_IN_NUMERICAL_TESTLET = 3;
